module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedit"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For Tony and Lorraine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I wish to express my deep gratitude to Paul Cartledge, who kindly agreed to read my manuscript at late stage and corrected many factual and stylistic errors with his customary grace and esprit – for such as remain I take full responsibility – and to Mike Goldmark and Mick Jagger, whose indefatigability and inspiration have been exemplary and determinative. Above all, I wish to thank Tony Aveni, my colleague at Colgate University, master equally of the anecdote and of the idea.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89d23fd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedi.vue
// module id = 60
// module chunks = 0